import SelectCardApi from "@/api/cardBind";
import { Component, Vue } from "vue-property-decorator";

const style = require("./index.module.scss");

interface UserInfoVo {
  phone: string;
  userName: string;
  idCardNo: string;
}
@Component({ name: "YXHContractCheck" })
export default class YXHContractCheck extends Vue {
  private userInfoMation: UserInfoVo = {
    phone: "",
    userName: "",
    idCardNo: "",
  };

  private async created() {
    const userInfo = await SelectCardApi.getUserInfomation();

    if (userInfo) {
      this.userInfoMation.userName = userInfo.userName;
      this.userInfoMation.idCardNo = userInfo.idCardNo;
    }
  }

  // 年月日
  private renderDate() {
    const d = new Date();
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  }

  private render() {
    return (
      <div class={style.YXHContractCheck}>
        <p class={style.title}>
          <strong>授权书</strong>
        </p>
        <p>
          <strong>重要提示：</strong>
        </p>
        <p>
          <strong>
            &nbsp;&nbsp;尊敬的客户：为了维护您的利益，在您签署本授权书之前，仔细阅读本授权书各条款（特别是黑体字条款），关注您在授权书中的权利、义务。若有任何疑问，可向经办人员咨询。
          </strong>
        </p>
        <p>
          <strong>
            &nbsp;&nbsp;海南宜信普惠小额贷款有限公司、（以下简称“贵公司”）：
          </strong>
        </p>
        <p>本人在通过借款平台申请借款过程中，就本人个人信息作出如下授权：</p>
        <p>
          <strong>
            &nbsp;&nbsp;一、本人同意并授权贵公司收集、使用、储存本人通过借款平台页面填写提交的信息或借款平台经过本人授权收集的信息。
          </strong>
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <strong>
            二、本人同意并授权借款平台有权将经过本人授权收集的本人信息共享或传输至贵公司。
          </strong>
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <strong>
            {" "}
            三、本人同意贵公司为完成对本人的资信评估采集、使用、储存、整理、加工本人姓名、手机号码、身份证正反面照片、人脸识别信息、银行卡信息、手机设备等信息。
          </strong>
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp; 四、本人同意并不可撤销的授权：
          <strong>
            {" "}
            贵公司（包括贵公司分支机构）可以依据国家相关规定自行或委托第三方合作机构采集并向金融信用信息基础数据库、北京宜信致诚信用管理有限公司、致诚阿福技术发展（北京）有限公司以及其他依法设立的征信机构提供符合相关规定的本人相关个人信息和信用信息（包括本人在贵公司办理业务过程中产生的不良信息）。
          </strong>
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;五、本人同意并不可撤销的授权：
          <strong>
            {" "}
            贵公司（包括贵公司分支机构）可以依据国家相关规定自行或委托第三方合作机构通过金融信用信息基础数据库、北京宜信致诚信用管理有限公司、致诚阿福技术发展（北京）有限公司以及其他依法设立的征信机构和相关依法成立的信息数据提供机构，查询、打印、保存及对外提供符合相关规定的本人相关个人信息和信用信息。
          </strong>
          用途如下：（一）审核本人个人贷款申请的；（二）审核本人或配偶作为担保人的；（三）受理本人担任法定代表人、负责人或出资人的法人或其他组织的借款申请的；（四）受理本人担任法定代表人、负责人或出资人的法人或其他组织作为担保人的。
        </p>
        <p> 授权人签名：{this.userInfoMation.userName}</p>
        <p class={style.idCard}>身份证号码：{this.userInfoMation.idCardNo}</p>
        <p>日 期：{this.renderDate()}</p>
      </div>
    );
  }
}
